import Projects from "../components/projects_section/Projects";
import Skills from "../components/skills_section/Skills";
import AboutSec from "../components/about_section/About";
import Contact from "../components/contact_section/Contact";
import About from "../components/first_section_about/About";
const Home_page = () => {
    //  right now in the last videos we complete this page :))
    // dont forget to subscribe
  return (
    <>
      <About />
      <Projects />
      <Skills />
      <AboutSec />
      <Contact />
    </>
  );
};
export default Home_page;
